/* eslint-disable import/prefer-default-export */

/* eslint-disable func-names */
import { callApiServiceCommon } from "../service-common";

const apiLink = process.env.REACT_APP_API;

export function* getListTemplateCampaignService() {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/list-template-campaigns`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getListCampaignByTypeService(campaignType) {
  let param = {};
  if (campaignType) {
    param = {
      campaign_type: campaignType,
    };
  }
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/list-campaigns-email`,
    params: param,
  };
  return yield callApiServiceCommon(payload);
}

export function* sendTestEmail(param) {
  const payload = {
    method: "POST",
    url: `${apiLink}/v2/send-test`,
    params: {
      data_html_selected: param.dataTmp.html,
      from_admin: param.campaignData.get("from_admin"),
      from_name: param.campaignData.get("from_name"),
      to_client: param.email,
      subject: param.campaignData.get("subject"),
      reply_to: param.campaignData.get("reply_to"),
      owner_first_name: param.shopInfo.owner_first_name,
      owner_last_name: param.shopInfo.owner_last_name,
      owner_title: param.shopInfo.owner_title,
      shop_name: param.shopInfo.shop_name,
      address: param.shopInfo.address,
      phone_number: param.shopInfo.phone_number,
      website: param.shopInfo.website,
      email: param.email,
      order_name: param.orderName,
      first_name: param.firstName,
      last_name: param.lastName,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingCampaign(param) {
  const payload = {
    method: "POST",
    url: `${apiLink}/v2/save-campaigns-email`,
    params: {
      id: param.campaignData.get("id"),
      campaign_name: param.campaignData.get("campaign_name"),
      campaign_type: param.campaignData.get("campaign_type"),
      time_to_send: param.campaignData.get("time_to_send"),
      time_to_send_type: param.campaignData.get("time_to_send_type"),
      from_admin: param.campaignData.get("from_admin"),
      from_sender: param.campaignData.get("from_sender"),
      from_name: param.campaignData.get("from_name"),
      subject: param.campaignData.get("subject"),
      reply_to: param.campaignData.get("reply_to"),
      data_design_selected: JSON.stringify(param.dataDesign.design),
      data_html_selected: param.dataDesign.html,
    },
  };

  return yield callApiServiceCommon(payload);
}

export function* activeDisableCampaign({ id, status }) {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/active-campaigns-email`,
    params: {
      id,
      status,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* deleteCampaign({ id }) {
  const payload = {
    method: "POST",
    url: `${apiLink}/v2/delete-campaigns-email`,
    params: {
      id,
    },
  };

  return yield callApiServiceCommon(payload);
}

export function* getDataDesignSelected({ id }) {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/get-campaign-template`,
    params: {
      id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getCampaignData(req) {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/detail-campaigns-email`,
    params: {
      campaign_id: req.id,
    },
  };
  return yield callApiServiceCommon(payload);
}
